import { styled } from "@mui/material";
import Input from "@mui/material/Input";

const StyledTextContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledText = styled(Input)`
  height: 2.2857rem;
  padding: ${(props) => props.theme.wsc.spacing[1]};
  border: 1px solid ${(props) => props.theme.wsc.palette.neutral[500]};
  border-radius: ${(props) => props.theme.wsc.radius.m};
  background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  font-size: ${(props) => props.theme.wsc.typography.body1.fontSize};
  font-weight: ${(props) => props.theme.wsc.typography.body1.fontWeight};
  line-height: ${(props) => props.theme.wsc.typography.body1.lineHeight};
  caret-color: ${(props) => props.theme.wsc.palette.primary[300]};

  &:hover {
    background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
  }

  &:focus-within,
  &:focus {
    background-color: ${(props) => props.theme.wsc.palette.neutral[500]};
    border-color: ${(props) => props.theme.wsc.palette.neutral[0]};

    .MuiInputBase-input {
      &::placeholder {
        color: ${(props) => props.theme.wsc.palette.neutral[300]};
      }
    }
  }

  .MuiInputBase-input {
    &::placeholder {
      opacity: 1;
      color: ${(props) => props.theme.wsc.palette.neutral[200]};
    }

    &.Mui-disabled {
      -webkit-text-fill-color: ${(props) =>
        props.theme.wsc.palette.neutral[300]};

      &::placeholder {
        opacity: 0.5;
      }
    }
  }

  .MuiInputBase-root.Mui-disabled {
    color: ${(props) => props.theme.wsc.palette.neutral[400]};
  }

  &.Mui-disabled {
    background-color: ${(props) => props.theme.wsc.palette.neutral[800]};
  }

  &.Mui-error {
    border-color: ${(props) => props.theme.wsc.palette.warning[300]};
  }

  /* Prevents webkit browsers from applying their default white background on autofill */
  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition:
      background-color 0s 600000s,
      color 0s 600000s !important;
    color-scheme: dark;
  }
`;

export { StyledText, StyledTextContainer };
